export class MdZippyController {
  active: boolean = false;

  toggle() {
    this.active = !this.active;
  }
}



// WEBPACK FOOTER //
// ./src/component/zippy.controller.ts